import React from "react";
import { MessageSquare, ShieldCheck, Plane, FileCheck2, Warehouse, Truck } from "lucide-react";
import { useT } from "@/lib/i18n";
import LogisticsAnimation from "@/components/LogisticsAnimation";

export default function ProcessFlow() {
  const { t } = useT();
  const STEPS = [
    { icon: MessageSquare, title: t("proc.step1.t"), desc: t("proc.step1.d") },
    { icon: ShieldCheck, title: t("proc.step2.t"), desc: t("proc.step2.d") },
    { icon: Plane, title: t("proc.step3.t"), desc: t("proc.step3.d") },
    { icon: FileCheck2, title: t("proc.step4.t"), desc: t("proc.step4.d") },
    { icon: Warehouse, title: t("proc.step5.t"), desc: t("proc.step5.d") },
    { icon: Truck, title: t("proc.step6.t"), desc: t("proc.step6.d") },
  ];
  return (
    <section data-testid="process-flow" className="relative py-24 sm:py-28 overflow-hidden">
      <LogisticsAnimation variant="all" />
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl mb-14">
          <div className="zp-label">{t("proc.eyebrow")}</div>
          <h2 className="font-display text-3xl sm:text-5xl tracking-tighter mt-3">
            {t("proc.title.a")}{" "}
            <span className="text-[color:var(--zp-text-3)]">{t("proc.title.b")}</span>
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-5 sm:left-1/2 sm:-translate-x-1/2 top-0 bottom-0 w-px zp-step-line hidden sm:block" />
          <ol className="space-y-5 sm:space-y-10">
            {STEPS.map((s, i) => (
              <li
                key={i}
                data-testid={`process-step-${i}`}
                className={`grid sm:grid-cols-2 gap-6 items-center ${i % 2 === 1 ? "sm:[&>div:first-child]:order-2" : ""}`}
              >
                <div className={`${i % 2 === 1 ? "sm:text-right" : ""}`}>
                  <div className="zp-card p-7 inline-block w-full">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-[color:var(--zp-bg-2)] grid place-items-center text-[color:var(--zp-cyan-3)]">
                        <s.icon size={18} strokeWidth={1.7} />
                      </div>
                      <span className="text-[11px] uppercase tracking-[0.22em] text-[color:var(--zp-text-3)] font-semibold">
                        Step 0{i + 1}
                      </span>
                    </div>
                    <h3 className="font-display text-xl tracking-tight mt-4">{s.title}</h3>
                    <p className="text-[color:var(--zp-text-2)] text-sm mt-2 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
                <div className="hidden sm:flex justify-center">
                  <div className="w-12 h-12 rounded-full border border-[color:var(--zp-cyan-2)] bg-white grid place-items-center zp-glow">
                    <span className="font-display text-lg text-[color:var(--zp-navy)]">0{i + 1}</span>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
